import React, { useEffect, useState } from "react";
import API from "../Service/Baseservice";
import { FaChevronRight } from "react-icons/fa";
import "../FAQ/FAQPreview.css";

const Faqpreview = ({ previewNews }) => {
    const [faqList, setFaqList] = useState([]);
    const [categories, setCategories] = useState([]);
    const [active, setActive] = useState("");
    const [category, setCategory] = useState("");
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const [openIndex, setOpenIndex] = useState(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const rowsPerPage = 9;

  
    const fetchCategories = () => {
        API.post("faqsCategory_list/condition", {})
            .then((res) => {
                const categoryData = res?.data?.data?.data || [];
                const activeCategories = categoryData.filter(
                    (cat) => cat.active === 1 || cat.active === "1"
                );
                setCategories(activeCategories);
                if (activeCategories.length > 0) {
                    setActive(activeCategories[0].category_id); 
                    setCategory(activeCategories[0].category_id);
                }
            })
            .catch((err) => console.error("Failed to fetch categories:", err));
    };
    useEffect(() => {
        fetchCategories();
    }, []);

    useEffect(() => {
        fetchFaqs();
    }, [page, category, search]);

    const fetchFaqs = () => {
        setLoading(true);
        API.post("faqs_list/condition", {
            category_id: category || "",
            search: search || "",
            status: "active",
           
        })
            .then((res) => {
                let data = res?.data?.data?.data || [];
                if (previewNews) data = [previewNews, ...data];
                const totalCount = res?.data?.data?.data1?.[0]?.totalcount || data.length;
                setFaqList(data);
                setTotalPages(Math.ceil(totalCount / rowsPerPage));
            })
            .catch((err) => console.error("Failed to fetch FAQs:", err))
            .finally(() => setLoading(false));
    };

    const leftFaqs = faqList.filter((_, index) => index % 2 === 0);
    const rightFaqs = faqList.filter((_, index) => index % 2 !== 0);


    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };


    return (
        <div className="resources">
            <div className="shadow-sm latestnewscontent aboutus d-block mx-auto col-lg-10 margintopaboutuses">
                <h1 className="faq-title">FAQ</h1>
                <br />
             
                <p >Home </p>
                <i className="bi bi-chevron-right"></i>
               
            </div>

          

            <div className="faq-category-container">
                {categories.map((cat, i) => (
                    <button
                        key={cat.category_id}
                        className={`faq-category-btn ${active === cat.category_id ? "active" : ""}`}
                        onClick={() => {
                            setActive(cat.category_id);
                            setCategory(cat.category_id);
                            setPage(1);
                        }}

                    >
                        <span>{cat.category}</span>
                        <FaChevronRight className="arrow-icon" />
                    </button>
                ))}
            </div>

            {/* Search header */}
            <div className="faq-search-section">
                <h4 className="faq-search-title">Search Here. What You want to know</h4>
                <input
                    type="text"
                    className="faq-search-input"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value)
                        setPage(1);

                    }}
                />
            </div>

            <div className="faq-divider"></div>

            <div className="faq-grid">
                {faqList.map((item, index) => (
                    <div
                        key={index}
                        className={`faq-card ${openIndex === index ? "active" : ""} ${index === 0 ? "highlight-faq" : ""}`}
                        onClick={() => handleToggle(index)}
                    >
                        <div className="faq-card-header">
                            <div
                                className="faq-question"
                                dangerouslySetInnerHTML={{ __html: item.question }}
                            />
                            <FaChevronRight
                                className={`arrow-icon ${openIndex === index ? "rotate" : ""}`}
                            />
                        </div>
                        {openIndex === index && (
                            <div
                                className="faq-answer"
                                dangerouslySetInnerHTML={{ __html: item.answers }}
                            />
                        )}
                    </div>
                ))}
            </div>

            {/* Pagination */}
            <div className="faq-pagination">
                {Array.from({ length: totalPages }, (_, i) => (
                    <button
                        key={i}
                        className={`page-btn ${page === i + 1 ? "active" : ""}`}
                        onClick={() => setPage(i + 1)}
                    >
                        {i + 1}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Faqpreview;
